module.exports = __webpack_public_path__ + "static/media/delete.342998ba.svg";